<template>
  <div v-html="useSanitizeHtml(element.markup)" />
</template>
<script setup lang="ts">
import { type WebformElementMarkupBaseFragment, type WebformSubmissionValidationErrorFragment } from '#graphql-operations'

defineProps<{
  element: WebformElementMarkupBaseFragment
  formErrors: WebformSubmissionValidationErrorFragment[]
}>()
</script>
